import React from 'react';
import PropTypes from 'prop-types';
import BrowserWarningModal from '~/components/BrowserWarningModal';
import * as S from './styles';

export default function DefaultLayout({ children }) {
  return (
    <S.Wrapper>
      <div id="modal-root" />
      <S.Container>
        {children}
        <BrowserWarningModal />
      </S.Container>
    </S.Wrapper>
  );
}

DefaultLayout.propTypes = {
  children: PropTypes.node.isRequired,
};
